import { render, staticRenderFns } from "./Design.vue?vue&type=template&id=6f8ec5b2"
import script from "./Design.vue?vue&type=script&lang=js"
export * from "./Design.vue?vue&type=script&lang=js"
import style0 from "./Design.vue?vue&type=style&index=0&id=6f8ec5b2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports